import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";

interface MyTimeCloseActionSectionProps {
  disabled: boolean;
  onCloseClick: () => void;
}

export const MyTimeCloseActionSection: React.FC<
  MyTimeCloseActionSectionProps
> = ({ disabled, onCloseClick }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      paddingBottom="16px"
    >
      <Button
        id="closing-period-button"
        variant="contained"
        color="primary"
        disabled={disabled}
        disableElevation
        onClick={onCloseClick}
      >
        {t("MY_TIME_CLOSING_PERIOD")}
      </Button>
    </Box>
  );
};

export default MyTimeCloseActionSection;
